import React from 'react'
import DynamicColor from '../../common/dynamic-color'
import { COLOR_NAME } from '../../../constants'

import ArrowNextSquare from '../../../assets/images/square-arrow-next.svg'

const MethodItem = ({ title, image, onClick }) => {
    return (
        <DynamicColor className="receive-method__item">
            <div onClick={onClick} className="receive-method__content">
                <div className="method-icon">
                    <img src={image} />
                </div>

                <div className="icon-next">
                    <img src={ArrowNextSquare} />
                </div>
            </div>

            <DynamicColor
                style={{ color: COLOR_NAME.MODAL_TEXT }}
                className="method-name mt-4"
            >
                <b>{title}</b>
            </DynamicColor>
        </DynamicColor>
    )
}

export default MethodItem
